import React, { useState } from "react";
import '../sass/components/_components.programNameGenerator.scss';

const ProgramNameGenerator = () => {
  const [formData, setFormData] = useState({
    product: "",
    region: "",
    audience: "",
    channel: "",
    day: "",
    programName: "",
  });

  const [generatedName, setGeneratedName] = useState("");

  const options = {
    product: { FIN: "Finance", MKTG: "Marketing", HR: "HR", ACCT: "Accounting", ALL: "All" },
    region: { APAC: "APAC", EMEA: "EMEA", GLOBAL: "GLOBAL", LATAM: "LATAM", NORAM: "NORAM", DACH: "DACH" },
    audience: { PS: "Prospects", CU: "Customers", CP: "Channel Partners", DB: "Database" },
    channel: {
      Web: "Website",
      Blog: "Blog",
      Chat: "Chat Request",
      CS: "Content Syndication",
      CW: "Co-Hosted Webinar",
      CN: "Customer Newsletter",
      DM: "Direct Mail",
      EM: "Email",
      FE: "Field Event",
      HE: "Hosted Event",
      IW: "Internal Webinar",
      OA: "Online Advertisement",
      PE: "Paid Email",
      PP: "Paid Promotion",
      PW: "Paid Webinar",
      SM: "Social Media",
      NU: "Nurture",
      TS: "Trade Show",
      WD: "Webinar Demo",
      Survey: "Survey",
      AR: "Analyst Report",
    },
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleDateChange = (e) => {
    const selectedDate = new Date(e.target.value);
    const formattedDate = `${selectedDate.getFullYear()}_${String(selectedDate.getMonth() + 1).padStart(2, "0")}_${String(selectedDate.getDate()).padStart(2, "0")}`;
    setFormData({ ...formData, day: formattedDate });
  };

  const generateProgramName = () => {
    const { product, region, audience, channel, day, programName } = formData;
    if (!product || !region || !audience || !channel || !day || !programName) {
      setGeneratedName("⚠️ Please fill all fields before generating!");
      return;
    }
    const programNameFormatted = programName.replace(/\s+/g, "-").toUpperCase();
    setGeneratedName(`${product}_${region}_${audience}_${channel}_${day}_${programNameFormatted}`);
  };

  return (
    <div className="container l--webTool">
      <h1>Marketo Program Name Generator</h1>
      <form>
        {Object.keys(options).map((key) => (
          <div key={key} className="form-group">
            <label>{key.charAt(0).toUpperCase() + key.slice(1)}:</label>
            <select name={key} onChange={handleChange} value={formData[key]}>
              <option value="">Select {key}</option>
              {Object.entries(options[key]).map(([code, label]) => (
                <option key={code} value={code}>{label}</option>
              ))}
            </select>
          </div>
        ))}

        <div className="form-group">
          <label>Select Date:</label>
          <input type="date" name="day" onChange={handleDateChange} />
        </div>

        <div className="form-group">
          <label>Program Name:</label>
          <input type="text" name="programName" placeholder="Enter program name" onChange={handleChange} />
        </div>

        <button type="button" className="generate-btn" onClick={generateProgramName}>
          Generate Program Name
        </button>
      </form>

      <h2>Generated Program Name:</h2>
      <p className="output">{generatedName}</p>
    </div>
  );
};

export default ProgramNameGenerator;